import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn } from 'intact-vue';
import { CollapseItem } from './item';
import { mapChildren, getRestProps } from '../utils';
import { makeStyles } from './styles';
import { isNullOrUndefined } from 'intact-shared';
import { directClone } from 'intact-vue';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    arrow = _this$get.arrow,
    noBorder = _this$get.noBorder;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-collapse"] = true, _classNameObj[makeStyles(k)] = true, _classNameObj[className] = className, _classNameObj[k + "-left"] = arrow === 'left', _classNameObj[k + "-border"] = !noBorder, _classNameObj);
  var _children = mapChildren(children, function (vNode, index) {
    if (vNode.tag === CollapseItem) {
      var props = _extends({}, vNode.props);
      if (isNullOrUndefined(props.value)) {
        props.value = "$" + index;
      }
      var clonedVNode = directClone(vNode);
      clonedVNode.props = props;
      return clonedVNode;
    }
    return vNode;
  });
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), _children);
}
;